import React, { useState, useEffect } from "react";
import "../CSS/styles.css";
import slider1 from "../../assets/slider1.png";
import sl from "../../assets/slider1.png";
import AOS from 'aos';
import 'aos/dist/aos.css';

const images = [sl, slider1];

const Slider1 = () => {
      useEffect(() => {
        AOS.init({
          duration: 1000,
          once: false,
        });
      }, []);
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((currentIndex - 1 + images.length) % images.length);
  };

  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % images.length);
  };

  return (
    <div className="container-fluid mt-lg-5 px-0 position-relative" data-aos="fade-down">
      <div className="row pt-4">
        <div
          className="col-12 slider position-relative pe-0 overflow-hidden"
          style={{ height: "auto" }}
        >
          <div
            className="slides-wrapper"
            style={{
              display: "flex",
              width: `${images.length * 100}%`,
              transform: `translateX(-${(currentIndex * 100) / images.length
                }%)`,
              transition: "transform 0.6s ease-in-out",
            }}
          >
            {images.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`slide-${idx}`}
                style={{
                  width: `${100 / images.length}%`,
                  flexShrink: 0,
                  objectFit: "cover",
                }}
                className="img-fluid"
              />
            ))}
          </div>

          <div
            className="overlay-content pe-0 inter d-flex flex-column justify-content-center align-items-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              pointerEvents: "none",
            }}
          >
            <div
              className="d-flex justify-content-center"
              style={{ pointerEvents: "auto" }}
            >
            </div>

            <div className="d-flex justify-content-center">
              <h1 className="fw-bolder h11 ps-2 mt-0 h0">
                Empowering Organizations <br />with Intelligence, Resilience <br />& Innovation
              </h1>
            </div>

            <div
              className="d-flex justify-content-between w-100 px-4"
              style={{ pointerEvents: "auto" }}
            >
              <div className="align-self-start">
                <button
                  className="btn"
                  onClick={prevSlide}
                  aria-label="Previous Slide"
                >
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="60"
                      height="60"
                      rx="10"
                      transform="matrix(-1 0 0 1 60 0)"
                      fill="white"
                    />
                    <path d="M34 22L26 30L34 38V22Z" fill="black" />
                  </svg>
                </button>
              </div>
              <div className="align-self-end">
                <button
                  className="btn"
                  onClick={nextSlide}
                  aria-label="Next Slide"
                >
                  <svg
                    width="60"
                    height="60"
                    viewBox="0 0 60 60"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="60" height="60" rx="10" fill="white" />
                    <path d="M26 22L34 30L26 38V22Z" fill="black" />
                  </svg>
                </button>
              </div>
            </div>

            <p
              className="fw-medium fs-5 nm text-center"
              style={{ pointerEvents: "auto" }}
            >
              Global expertise in Risk, Crisis & Digital Security Solutions
            </p>

            <div
              className="d-flex justify-content-center align-items-center pt-4"
              style={{ pointerEvents: "auto" }}
            >
              <button className="explore py-lg-3 py-md-3 px-md-4 px-lg-4 fw-medium fs-lg-0 fs-6-5 py-2 px-3">
                Explore Services
              </button>
                <button
                  className="lets ms-3 px-5 fw-medium py-lg-3 py-2 nav-item fs-6-5"
                  type="button"
                  onClick={handleShow}
                >
                  Let's Talk
                </button>
                <div
                  className={`modal fade ${showModal ? 'show d-block' : 'd-none'}`}
                  tabIndex="-1"
                  style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
                  aria-modal={showModal}
                  role="dialog"
                >
                  <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxWidth: '26%' }}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleClose}
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body text-start">
                        <form>
                          <h5 className="fw-semibold mb-0 bc">Let's Talk</h5>
                          <p className="gc fs-6-5 mb-0 mt-2">We'd love to discuss your project. Fill out the form and our experts will reach out.</p>
                          <p className="gc mb-1 fs-7 mt-4">Name</p>
                          <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Name" />
                          <p className="gc mb-1 fs-7 mt-3">Email</p>
                          <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="your.email@example.com" />
                          <p className="gc mb-1 fs-7 mt-3">Phone</p>
                          <input type="text" name="name" id="name" className="w-100 custom-input py-2 ps-2" placeholder="Your Phone Number" />
                          <p className="gc mb-1 fs-7 mt-3">Service of Interest</p>
                          <select name="Service" className="w-100 ps-2 custom-input py-2" id="1">
                            <option value="1">Select a service</option>
                            <option value="2">Risk Management</option>
                            <option value="3">Crisis Management</option>
                            <option value="4">Project Support</option>
                            <option value="5">Research & Analysis</option>
                            <option value="6">GIS</option>
                            <option value="7">Cyber Security</option>
                            <option value="8">Training & Capacity Building</option>
                            <option value="9">Digital Solutions</option>
                          </select>
                          <p className="gc mb-1 fs-7 mt-3">Message</p>
                          <div class="mb-3">
                            <textarea class="form-control" id="exampleFormControlTextarea1" placeholder="Tell us about your project or inquiry" rows="3" className="w-100 custom-input p-2"></textarea>
                          </div>
                          <div>
                            <button type="button" className="talk w-100 py-2 fw-medium fs-6-5" onClick={handleClose}>
                              Submit
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider1;
